import INewsItem from "../typings/INews";
import http from "./client";

export interface INewsListQueryParams {
  page?: number;
  limit?: number;
}

export interface INewsResponse {
  success: boolean;
  errorMessage?: string;
  paginator?: {
    limit: number;
    page: number;
    pageCount: number;
    totalItemCount: number;
  },
  metaData?: any;
  data?: Array<INewsItem>;
}

async function list (queryParams: INewsListQueryParams, courseId: number | string, byAuthor: boolean): Promise<INewsResponse> {
  const url = byAuthor ? '/api/v2/news' : `/api/v2/course/${courseId}/news`;

  const response = await http.get<INewsResponse>(url, {
    params: { ...queryParams, course_id: courseId }
  });
  
  return response.data;
}

async function create(newsItem: INewsItem, courseId: number | string): Promise<INewsItem> {
  const response = await http.post('/api/v2/news', newsItem, { params: { course_id: courseId } });

  return response.data.data;
}

async function update(newsItem: INewsItem, courseId: number | string): Promise<INewsItem> {
  const response = await http.put(`/api/v2/news/${newsItem.id}`, newsItem, { params: { course_id: courseId } });
  
  return response.data;
}

async function remove(newsItem: INewsItem, courseId: number | string) {
  const response = await http.delete(`/api/v2/news/${newsItem.id}`, { params: { course_id: courseId } });

  return response.data;
}

const news = {
  list, create, update, remove
}

export default news;